module.exports = __webpack_public_path__ + "static/media/feature-filter-price@2x.bc60a4f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/feature-filter-price@2x.png
// module id = 172
// module chunks = 0